import * as Yup from 'yup';

export class UpdateAreaValidator {
  public get schema() {
    return Yup.object()
      .shape({
        name: Yup.string().required('Informe o nome da área'),
        code: Yup.string().required('Informe o código da área'),
        isDockManagement: Yup.boolean().required(),
      })
      .noUnknown();
  }
}
